export default "__VITE_ASSET__D0An1IPu__"